<template>
  <div>
    <div>
      <!-- <div class="text-xs-center mt-5" v-if="campaignLoading">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>
      <div v-else style="display: flex; justify-content: space-between; flex: wrap">
        <div>
          <span class="pr-2">เลือกแคมเปญ</span>
          <v-btn
            active-class="primary"
            v-for="c in campaigns"
            :key="c.id"
            @click="chooseCampaign(c)"
            :outline="currentCampaign.name != c.name"
            :color="currentCampaign.name == c.name ? 'primary' : 'grey'"
            >{{ c.name }}</v-btn
          >
        </div>
        <div>
          <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
        </div>
      </div> -->
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs6>
          <v-btn
            v-if="selectCampaign && !loading && !campaignLoading"
            outline
            color="primary"
            @click="showAdd"
            ><v-icon>add</v-icon>เพิ่มรางวัล</v-btn
          >

          <v-dialog v-model="editrewarddialog" width="720px" persistent
            ><v-card v-if="editrewarddialog && selectCampaign">
              <RewardEdit
                :campaign-id="selectCampaign.id"
                :selected-catogory="selectedcategory"
                :selected-campaign="selectCampaign"
                :edittype="edittype"
                :editdata="editdata"
                @onsave="onsave"
                @close="editrewarddialog = false"
              ></RewardEdit></v-card
          ></v-dialog>
        </v-flex>
        <v-flex xs6>
          <RewardCategory
            :campaign-id="selectCampaign.id"
            @change="onChangeCategory"
          ></RewardCategory>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-right">
      <v-pagination
        v-if="!loading"
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </div>
    <div v-if="loading" class="text-xs-center mt-5">
      <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
    </div>
    <div v-else id="body-reward" class="mt-2">
      <div v-if="items.length">
        <div
          v-for="(item, index) in items"
          :key="`reward-card-${index}`"
          style="border: 2px solid #1548a7; border-radius: 16px; position: relative"
          class="pa-2 elevation-3 mb-3"
        >
          <div class="text-xs-right">
            <v-btn icon @click="showEditReward(item)"><v-icon color="#1548a7">edit</v-icon></v-btn>
            <v-btn icon @click="deleteReward(item)"><v-icon color="#1548a7">delete</v-icon></v-btn>
          </div>
          <v-layout row wrap class="px-4 ma-0">
            <v-flex xs3>
              <div>
                <v-img aspect-ratio="1" :src="item.photo"></v-img>
              </div>
            </v-flex>
            <v-flex xs9 class="pl-4">
              <div>
                <h2 class="primary--text" style="color: black">{{ item.name }}</h2>
                <div>
                  <span>Description : </span>
                  <span>{{ item.description }}</span>
                </div>
                <div>
                  <span>รหัสสินค้า : </span>
                  <span>{{ item.sku }}</span>
                </div>
                <div>
                  <span>Quantity : </span>
                  <span>{{ item.quantity }}</span>
                </div>
                <div>
                  <span>Start Date : </span>
                  <span>{{ item.effective_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
                <div>
                  <span>End Date : </span>
                  <span>{{ item.end_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
              </div>

              <div
                v-if="selectCampaign && selectCampaign.type != 'lucky_draw'"
                style="color: #1548a7; float: right; font-size: 18px"
              >
                ใช้ {{ item.points | numberFormat }} แต้ม
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-else>
        <div class="grey--text text-xs-center mt-5" style="font-size: 22px">ไม่พบข้อมูล</div>
      </div>
    </div>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <!-- <label>{{ $t('รหัสสาขาของห้าง') }}</label> -->
                <input v-model="filter.search" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RewardCategory from './RewardCategory.vue'
import RewardEdit from './RewardEdit.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    RewardCategory,
    RewardEdit
  },
  data() {
    return {
      filter: {
        search: ''
      },

      items: [],
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      editrewarddialog: false,
      loading: false,
      edittype: '',
      editdata: '',
      selectedcategory: '',
      showCategory: false,
      cardData: [],
      selectedCampaignId: null,
      campaignLoading: false,
      currentCampaign: null
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    campaigns: {
      get() {
        return this.$store.state.toaEcouponCampaigns
      },
      set(val) {
        this.$store.state.toaEcouponCampaigns = val
      }
    },

    ...mapGetters(['selectedBot']),

    selectCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  mounted() {
    // this.getEnabledCampagin()

    this.getData()
  },
  methods: {
    showEditReward(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.editrewarddialog = true
    },
    onsave() {
      this.getData()
      this.editrewarddialog = false
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    deleteReward(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
              page_id: this.selectedBot.pageid,
              id: item.id
            }
            this.loading = true

            if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
              try {
                await toaMegapaintApi.daleteEcouuponCampaignProduct(data)
                this.getData()
              } catch (error) {
                console.error(error)
              } finally {
                this.loading = false
              }
            } else {
              api.TOAECOUPONDeleteRewardProduct(data, (err, response) => {
                this.loading = false
                this.getData()
              })
            }
          }
        })
    },
    async getData() {
      this.loading = true
      const data = {
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid,
        category_id: this.selectedcategory ? this.selectedcategory.id : '',
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
        search: this.filter.search, // filter
        limit: this.limit,
        offset: this.offset
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let response = await toaMegapaintApi.getEcouuponCampaignProduct(data)
          response = response.data
          this.loading = false
          this.items = response.data
          this.total = response.total
        } catch (error) {
          console.error(error)
        }
      } else {
        api.TOAECOUPONGetRewardProduct(data, (err, response) => {
          this.loading = false
          this.items = response.data
          this.total = response.total
        })
      }
    },
    clearsearch() {
      this.filter.search = ''
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    showAdd() {
      this.edittype = 'create'
      this.editrewarddialog = 'true'
    },
    onChangeCategory(e) {
      this.selectedcategory = e
      this.getData()
    },
    onCategoryChange: function () {
      let vm = this
    },
    async getEnabledCampagin() {
      this.campaignLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let result = await toaMegapaintApi.getCampaign(payload)
          result = result.data
          this.campaignLoading = false
          this.campaigns =
            result.data.length > 0 ? result.data.filter((f) => f.type == 'collect') : []
          if (this.campaigns && this.campaigns.length > 0) {
            this.currentCampaign = this.campaigns[0]
            this.selectedCampaignId = this.campaigns[0].id
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        api.TOAECOUPONgetAllCampaign(payload, (err, result) => {
          if (result.responsecode == 200) {
            this.campaignLoading = false
            this.campaigns =
              result.data.length > 0 ? result.data.filter((f) => f.type == 'collect') : []
            if (this.campaigns && this.campaigns.length > 0) {
              this.currentCampaign = this.campaigns[0]
              this.selectedCampaignId = this.campaigns[0].id
            }
          }
        })
      }
    },
    chooseCampaign(campaign) {
      this.selectedCampaignId = campaign.id
      this.currentCampaign = campaign
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.pos-top-r {
  position: absolute;
  right: 15px;
  top: 15px;
  color: rgb(64, 131, 255);
}
.pos-bot-r {
  position: absolute;
  right: 15px;
  bottom: 15px;
  color: rgb(64, 131, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Reward.vue